import styled from "@emotion/styled";
import dayjs from "dayjs";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { MOBILE_WIDTH } from "../../utils/HelperStyles";
import { useModal } from "../Modal/Modal";
import StyledButton from "../StyledButton";
import NumberContainer from "./NumberContainer";

const Wrapper = styled.div`
  height: 75px;

  display: flex;
  align-items: center;
  justify-content: center;
  /* position: sticky; */
  width: 100%;
  padding: 10px;
  background-color: #ff644e;

  @media (max-width: ${MOBILE_WIDTH}) {
    height: 148px;

    flex-direction: column;
    justify-content: center;
  }
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  margin-left: 25px;
  margin-right: 25px;

  @media (max-width: ${MOBILE_WIDTH}) {
    margin-top: 5px;
    margin-bottom: 5px;
  }
`;

const NumberDiv = styled.div`
  margin-right: 10px;
  margin-left: 10px;
`;

interface ITestDriveBanner {
  endTime: number;
}

export default function TestDriveBanner(props: ITestDriveBanner): JSX.Element {
  const { endTime } = props;

  const router = useRouter();

  const [timeToEnd, setTimeToEnd] = useState(getNewTime());
  const modal = useModal();

  function getNewTime() {
    const time = dayjs(endTime);
    const now = Date.now();
    const days = time.diff(now, "days");
    const hrs = time.diff(now, "hour");
    const min = time.diff(now, "minutes");
    const sec = time.diff(now, "seconds");

    return {
      days,
      hrs: hrs - days * 24,
      min: min - hrs * 60,
      sec: sec - min * 60,
    };
  }

  useEffect(() => {
    const interval = setInterval(() => {
      const time = getNewTime();
      setTimeToEnd(time);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <Wrapper>
      <div>Your chance to get BerserkerMail at the current price ends in</div>
      <Flex>
        <NumberDiv>
          <NumberContainer
            text="DAYS"
            value={timeToEnd.days.toLocaleString("en-US", {
              minimumIntegerDigits: 2,
            })}
          />
        </NumberDiv>
        <NumberDiv>
          <NumberContainer
            text="HRS"
            value={timeToEnd.hrs.toLocaleString("en-US", {
              minimumIntegerDigits: 2,
            })}
          />
        </NumberDiv>
        <NumberDiv>
          <NumberContainer
            text="MIN"
            value={timeToEnd.min.toLocaleString("en-US", {
              minimumIntegerDigits: 2,
            })}
          />
        </NumberDiv>
        <NumberDiv>
          <NumberContainer
            text="SEC"
            value={timeToEnd.sec.toLocaleString("en-US", {
              minimumIntegerDigits: 2,
            })}
          />
        </NumberDiv>
      </Flex>
      <div>
        <StyledButton
          onClick={() => {
            router.replace("/settings?screen=BILLING");
          }}
          inverted
        >
          Activate Now
        </StyledButton>
      </div>
    </Wrapper>
  );
}
